export enum AiprizeCompanyDecision {
    Approved = 'approved',
    Declined = 'declined',
    Unknown = 'unknown',
    Review = 'review',
}
